import { Open_Sans, DM_Sans } from "next/font/google";
import { ThemeName } from "@filadd/phi-plus-styled-system/themes";

const openSans = Open_Sans({
  style: "normal",
  subsets: ["latin"],
});

const dmSans = DM_Sans({
  style: "normal",
  subsets: ["latin"],
});

const fonts = {
  filadd: openSans,
  kuadro: dmSans,
};

export const getThemeFont = (themeName?: ThemeName) => {
  const THEME_NAME = (process.env.THEME as ThemeName) || "filadd";
  const selectedTheme = themeName || THEME_NAME;

  return fonts[selectedTheme] || openSans;
};

export { openSans, dmSans, fonts };
